import { render, staticRenderFns } from "./CrmEditCloseEvent.vue?vue&type=template&id=5f63e426"
import script from "./CrmEditCloseEvent.vue?vue&type=script&lang=ts"
export * from "./CrmEditCloseEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f63e426')) {
      api.createRecord('5f63e426', component.options)
    } else {
      api.reload('5f63e426', component.options)
    }
    module.hot.accept("./CrmEditCloseEvent.vue?vue&type=template&id=5f63e426", function () {
      api.rerender('5f63e426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/edit/CrmEditCloseEvent.vue"
export default component.exports